import { EventEmitter } from "events";
import * as types from "./ModalEventType";
export const ModalEvent = new EventEmitter();
export function showModal(data) {
  ModalEvent.emit(types.SHOW, data);
}

export function hideModal() {
  ModalEvent.emit(types.HIDE);
}

export function showNGWord() {
  ModalEvent.emit(types.SHOW, {
    text:
      "このメッセージは、<br>センシティブな内容が含まれている<br>可能性があるため投稿できません"
  });
}

export function showDeleteMessage() {
  ModalEvent.emit(types.SHOW, {
    opaque: true,
    text:
      "メッセージに<br>センシティブな内容が含まれていたため、<br>削除しました。"
  });
}

export function showAPIError(errMessage) {
  ModalEvent.emit(types.SHOW, {
    text: "エラーが発生しました<br>しばらくしてから再度お試しください。",
    err: errMessage
  });
}

export function showGPSError(code) {
  let title = "投稿可能エリア範囲外です";
  if (code) {
    switch (code) {
      case 1:
        title = "位置情報サービスが無効です";
        break;
      case 2:
        title = "デバイスの位置が判定できませんでした";
        break;
      case 3:
        title = "位置取得に時間がかかりすぎています";
        break;
      default:
        title = "位置情報サービスでエラーが<br>発生しました";
        break;
    }
  }
  ModalEvent.emit(types.SHOW, {
    opaque: true,
    top: "-14.6em",
    text: `<h2>${title}<span class='endLetter'>。</span></h2><p>端末の位置情報機能をONにして<span class='endLetter'>、</span><br>RENGA付近で再度お試しください<span class='endLetter'>。</span></p><p class='note note--8'>※「保存ボタン」で絵を保存できます。</p>`
  });
}

export function showBan() {
  ModalEvent.emit(types.SHOW, {
    opaque: true,
    text:
      "<p>お客様のメッセージ投稿は<br>規約違反が確認されたため<br>停止されています。"
  });
}

export function showEnv() {
  ModalEvent.emit(types.SHOW, {
    text:
      "<p>推奨環境以外のOS・ブラウザをご利用の場合、動作・表示が正しく行われない可能性があります。</p>" +
      "<p>推奨環境にてご利用ください。</p>",
    link: {
      text: "推奨環境はこちら",
      href: "spec"
    }
  });
}

export function showUseSmartphone() {
  ModalEvent.emit(types.SHOW, {
    text:
      "<p>RENGAはスマートフォン専用コンテンツです。<br>" +
      "スマートフォンからメッセージを描いて、ぴあアリーナMMで盛り上がろう！</p>"
  });
}
